import { bootstrapApp } from '@backoffice-frontend/authenticated-app-view'
import { App } from './lib/App'

bootstrapApp(
  App,
  'https://8591825086f8b8654479b900512fe78a@o4508878881685504.ingest.de.sentry.io/4510516304674896',
)
